import React from "react";
import PropTypes from "prop-types";

import { MultiToggle } from './MultiToggle';
require("./MultiToggle.css");

const groupOptions = [
	{
		displayName: ' ',
		selectedDisplayName: 'NOK',
		value: 2,
		optionClass: 'red'
	},
	{
		displayName: ' ',
		selectedDisplayName: 'Neutral',
		value: 0,
		optionClass: 'gray'
	},
	{
		displayName: ' ',
		selectedDisplayName: 'OK',
		value: 1,
		optionClass: 'green'
	},
];

const OKToggle = (props) => {
	const name = props.name;
	const onChange = props.onChange;
	const value = props.value;
	const disabled = props.disabled ? props.disabled : null;
	const kleurbalk = props.kleurbalk;
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";

	return (
		<div className={sizeClassName} >
			<div className={sizeClassName} style={{ display: "inline-block" }}>
				<MultiToggle
					kleurbalk={kleurbalk}
					disabled={disabled}
					options={groupOptions}
					selectedOption={value}
					onSelectOption={onChange}
					name={name}
				/>
			</div >
		</div >
	);
};

OKToggle.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	kleurbalk: PropTypes.bool,
	size: PropTypes.number
};

export default OKToggle;